import { Button } from '@mui/material';
import React from 'react';
import { ButtonBaseProps } from './button.types';

enum VariantValue {
  primary = 'contained',
  secondary = 'outlined',
  discreet = 'text',
}
type VaritantValueType = keyof typeof VariantValue;
type Props = ButtonBaseProps & {
  variant: VaritantValueType;
};

function ButtonBase({
  variant,
  fullWidth,
  iconRight,
  iconLeft,
  children,
  width,
  id,
  className,
  gap = '7px',
  ...rest
}: Props) {
  return (
    <Button
      disableElevation
      variant={VariantValue[variant]}
      sx={{
        width: fullWidth ? '100%' : width || 'auto',
        gap: gap,
      }}
      startIcon={iconLeft}
      endIcon={iconRight}
      {...rest}
      className={className || 'ui-button-' + VariantValue[variant]}
      id={id || 'ui-button-' + VariantValue[variant]}
    >
      {children}
    </Button>
  );
}

export default ButtonBase;
